import { ApiEndpoint } from "utils/baseFetcher";

export function consensusDividendPaymentsUrl(
  entityId: string,
  since: Date | string,
  to: Date | string
): any {
  const url = new ApiEndpoint("/api/v3/consensus/graphs/dividend-payments");
  url.searchParams.append("entity-id", entityId);
  url.searchParams.append("date-from", since.toString());
  url.searchParams.append("date-to", to.toString());
  return url.href;
}

export function consensusDividendYieldUrl(
  entityId: string,
  since: Date | string,
  to: Date | string
): any {
  const url = new ApiEndpoint("/api/v3/consensus/graphs/dividend-yield");
  url.searchParams.append("entity-id", entityId);
  url.searchParams.append("date-from", since.toString());
  url.searchParams.append("date-to", to.toString());
  return url.href;
}
